// AUTO-GENERATED from exported_templates/kubicle/catalog.json by tools/kubicle/gen-archetypes-frontend.ts. Do not edit by hand.
export interface KubicleArchetype { key: string; family: string; role: string; narrationShapes: string[]; useWhen: string; hasCharacter: boolean; previewUrl: string; }

export const KUBICLE_ARCHETYPES: KubicleArchetype[] = [
  {
    "key": "AIWorkflowDiagramV1",
    "family": "diagram",
    "role": "body",
    "narrationShapes": [
      "fan-out-flow"
    ],
    "useWhen": "Showing how a request flows through a branching pipeline that fans out to parallel handlers and fans back in (router/dispatcher, multi-agent orchestration, request lifecycle).",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/AIWorkflowDiagramV1/preview.png"
  },
  {
    "key": "BigPoints3V1",
    "family": "points",
    "role": "impact",
    "narrationShapes": [
      "impact",
      "single-concept"
    ],
    "useWhen": "You want 2-3 punchy top-level takeaways or benefits delivered as one confident, high-impact statement with a progress-bar flourish.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/BigPoints3V1/preview.png"
  },
  {
    "key": "BigPoints3V2",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration",
      "impact"
    ],
    "useWhen": "You have 2-3 parallel concepts, steps, or roles that each need a title PLUS a one-line explanation.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/BigPoints3V2/preview.png"
  },
  {
    "key": "BigPoints3V2Character",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration",
      "persona"
    ],
    "useWhen": "You have 2-3 roles, personas, or team archetypes where putting a human face on each one matters.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/BigPoints3V2Character/preview.png"
  },
  {
    "key": "BulletList6Pills",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration"
    ],
    "useWhen": "You need a simple readable list of 4-6 short items or steps where each is one line and order is sequential but not emphasized.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/BulletList6Pills/preview.png"
  },
  {
    "key": "Cards5Falling",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration",
      "process"
    ],
    "useWhen": "You want to reveal a 4-5 step process or journey as a dramatic falling-card sequence where each stage momentarily takes the full stage.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Cards5Falling/preview.png"
  },
  {
    "key": "Carousel5Tiles",
    "family": "points",
    "role": "impact",
    "narrationShapes": [
      "enumeration",
      "impact"
    ],
    "useWhen": "Revealing 3-5 named items one at a time with dramatic focus, each item carrying an icon, a title, and 1-2 supporting bullets.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Carousel5Tiles/preview.png"
  },
  {
    "key": "Carousel7PillsHorizontalV1",
    "family": "points",
    "role": "impact",
    "narrationShapes": [
      "enumeration"
    ],
    "useWhen": "Driving through 5-7 short single-word or two-word items as a high-energy horizontal sequence (stages of a cycle, a vocabulary run, a list of plays).",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Carousel7PillsHorizontalV1/preview.png"
  },
  {
    "key": "CharacterDuoCards",
    "family": "character",
    "role": "body",
    "narrationShapes": [
      "persona",
      "contrast"
    ],
    "useWhen": "Introducing exactly two people, personas, or contrasting roles together so the viewer reads them as a matched pair.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CharacterDuoCards/preview.png"
  },
  {
    "key": "CharacterProfileCard",
    "family": "character",
    "role": "impact",
    "narrationShapes": [
      "persona",
      "single-concept"
    ],
    "useWhen": "Spotlighting exactly one person, expert, founder, or persona with their title, bio, and social proof.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CharacterProfileCard/preview.png"
  },
  {
    "key": "CharacterTeam6Card",
    "family": "character",
    "role": "impact",
    "narrationShapes": [
      "persona",
      "enumeration"
    ],
    "useWhen": "Showing a full team roster of roughly six members where each face needs its own short function/role label on one shared card.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CharacterTeam6Card/preview.png"
  },
  {
    "key": "CharacterTeamCard",
    "family": "character",
    "role": "impact",
    "narrationShapes": [
      "persona",
      "enumeration"
    ],
    "useWhen": "Introducing a small team (about 3-5 people) as one collective unit with a shared name, bio, and stats rather than per-person detail.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CharacterTeamCard/preview.png"
  },
  {
    "key": "CharacterTrioCards",
    "family": "character",
    "role": "body",
    "narrationShapes": [
      "persona",
      "enumeration"
    ],
    "useWhen": "Introducing exactly three people, personas, or roles as a balanced trio across the slide.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CharacterTrioCards/preview.png"
  },
  {
    "key": "Checklist5Pills",
    "family": "points",
    "role": "summary",
    "narrationShapes": [
      "recap",
      "enumeration"
    ],
    "useWhen": "You want a checklist of 4-5 items presented as 'done/covered' with a human presenter, ideal as a recap or commitment slide.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Checklist5Pills/preview.png"
  },
  {
    "key": "CirclePoints4",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration"
    ],
    "useWhen": "Naming 3-4 parallel, co-equal concepts, pillars, or categories that each need only an icon and a short label.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CirclePoints4/preview.png"
  },
  {
    "key": "CirclePoints4Character",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration",
      "persona"
    ],
    "useWhen": "Presenting 3-4 parallel people, roles, or personas where a face per item adds warmth and identity.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CirclePoints4Character/preview.png"
  },
  {
    "key": "ComparativePoints2",
    "family": "comparison",
    "role": "body",
    "narrationShapes": [
      "contrast"
    ],
    "useWhen": "Show exactly two things in a connected or transformational relationship (input vs output, before vs after, A links to B), each summarised in one short label.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/ComparativePoints2/preview.png"
  },
  {
    "key": "CourseSummary",
    "family": "lesson-frame",
    "role": "summary",
    "narrationShapes": [
      "recap",
      "frame"
    ],
    "useWhen": "Close an entire course by recapping 4-6 module-level steps as a stacked list of icon pills.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/CourseSummary/preview.png"
  },
  {
    "key": "FivePoints1SubtopicV2",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration"
    ],
    "useWhen": "Walking through a 4-5 step ordered process or framework where each step needs a short title plus a one-line explanation and one step is the current focus.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/FivePoints1SubtopicV2/preview.png"
  },
  {
    "key": "FivePoints1SubtopicV2Character",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration",
      "persona"
    ],
    "useWhen": "Narrating a 4-5 step process or framework where you want a presenter figure anchoring the steps.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/FivePoints1SubtopicV2Character/preview.png"
  },
  {
    "key": "Flywheel4Petals",
    "family": "diagram",
    "role": "body",
    "narrationShapes": [
      "cycle"
    ],
    "useWhen": "Showing a 4-stage repeating cycle or loop where the stages feed back into each other (plan -> act -> observe -> reflect, a growth flywheel, an iterative agentic loop).",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Flywheel4Petals/preview.png"
  },
  {
    "key": "GroupChat",
    "family": "chat",
    "role": "body",
    "narrationShapes": [
      "dialogue"
    ],
    "useWhen": "Dramatizing a discussion among three or more named people (standup, war room, team debate) where multiple distinct voices matter.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/GroupChat/preview.png"
  },
  {
    "key": "IconPointsV1",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "enumeration"
    ],
    "useWhen": "You are recapping or listing 3-6 topics already covered (or about to be), and want a dynamic conveyor reveal rather than a static list.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/IconPointsV1/preview.png"
  },
  {
    "key": "KubicleAIChat",
    "family": "chat",
    "role": "body",
    "narrationShapes": [
      "dialogue"
    ],
    "useWhen": "Framing one question and a single structured AI answer that decomposes into ~4 numbered parts (explaining a concept as if asked of an AI assistant).",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/KubicleAIChat/preview.png"
  },
  {
    "key": "LessonGoal",
    "family": "lesson-frame",
    "role": "opener",
    "narrationShapes": [
      "frame",
      "single-concept"
    ],
    "useWhen": "State the single objective or outcome of a lesson in one sentence after the lesson title.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/LessonGoal/preview.png"
  },
  {
    "key": "LessonSummary",
    "family": "lesson-frame",
    "role": "closer",
    "narrationShapes": [
      "recap",
      "frame"
    ],
    "useWhen": "Close a lesson by recapping 3-5 short takeaways as a stacked list of pills.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/LessonSummary/preview.png"
  },
  {
    "key": "LessonTitle",
    "family": "lesson-frame",
    "role": "opener",
    "narrationShapes": [
      "frame"
    ],
    "useWhen": "Open a course or a numbered lesson with its title, a 'Lesson N' label, and the course name.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/LessonTitle/preview.png"
  },
  {
    "key": "OrgChart",
    "family": "diagram",
    "role": "body",
    "narrationShapes": [
      "hierarchy"
    ],
    "useWhen": "Showing a reporting structure or team hierarchy with named people and their titles across three levels (exec, leads, individual contributors).",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/OrgChart/preview.png"
  },
  {
    "key": "Points3Subtopics2",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "nested-points",
      "enumeration"
    ],
    "useWhen": "You have exactly 2-3 grouped concepts where each one needs two supporting detail lines, all under a shared anchor theme.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Points3Subtopics2/preview.png"
  },
  {
    "key": "Process5Steps",
    "family": "timeline",
    "role": "body",
    "narrationShapes": [
      "process"
    ],
    "useWhen": "Show a 4-5 stage directional pipeline or flow where each stage is a single word/short label and the forward arrow shape (each feeding the next) is the point.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Process5Steps/preview.png"
  },
  {
    "key": "Pyramid5Tiers",
    "family": "diagram",
    "role": "body",
    "narrationShapes": [
      "hierarchy"
    ],
    "useWhen": "Presenting a five-level layered hierarchy where each layer builds on the one beneath it (strategy stack, maturity levels, foundation-to-apex framework).",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Pyramid5Tiers/preview.png"
  },
  {
    "key": "Roadmap5Milestones",
    "family": "timeline",
    "role": "body",
    "narrationShapes": [
      "chronology",
      "process"
    ],
    "useWhen": "Lay out a 4-5 milestone plan or roadmap as a vertical list of cards, each with a title and a short descriptive line, with an aspirational launch/growth tone.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Roadmap5Milestones/preview.png"
  },
  {
    "key": "SplitscreenPointsV1",
    "family": "comparison",
    "role": "body",
    "narrationShapes": [
      "contrast"
    ],
    "useWhen": "Contrast two approaches or states across several parallel points each (typically 3-4 per side), where every point on the left has a counterpart on the right.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/SplitscreenPointsV1/preview.png"
  },
  {
    "key": "TextThread2Characters",
    "family": "chat",
    "role": "body",
    "narrationShapes": [
      "dialogue",
      "persona"
    ],
    "useWhen": "Showing a focused two-person back-and-forth (a Q&A, an approval handoff, a decision exchange) where exactly two voices alternate.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/TextThread2Characters/preview.png"
  },
  {
    "key": "Timeline5Tiles",
    "family": "timeline",
    "role": "body",
    "narrationShapes": [
      "chronology",
      "process"
    ],
    "useWhen": "Walk through a 4-5 step sequential process or journey where each step is a single short phrase and a thematic anchor icon ties the whole sequence together.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Timeline5Tiles/preview.png"
  },
  {
    "key": "Timeline5TilesCharacter",
    "family": "timeline",
    "role": "body",
    "narrationShapes": [
      "chronology",
      "process",
      "persona"
    ],
    "useWhen": "Present a 4-5 step sequential process with a human presenter on screen for a spokesperson or instructor-led feel.",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Timeline5TilesCharacter/preview.png"
  },
  {
    "key": "Timeline6Checkpoints",
    "family": "timeline",
    "role": "body",
    "narrationShapes": [
      "chronology"
    ],
    "useWhen": "Show a dated horizontal chronology of up to 6 milestones where each needs a date, a title, and a short sentence of detail.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Timeline6Checkpoints/preview.png"
  },
  {
    "key": "Topic1Subtopics6",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "nested-points",
      "enumeration"
    ],
    "useWhen": "Unpacking one topic, question, or definition into 4-6 short flat detail statements that share equal weight.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Topic1Subtopics6/preview.png"
  },
  {
    "key": "Topic1Subtopics6Character",
    "family": "points",
    "role": "body",
    "narrationShapes": [
      "nested-points",
      "enumeration",
      "persona"
    ],
    "useWhen": "Breaking one topic into 4-6 flat detail statements while keeping a presenter figure on screen (e.g. 'a day in the life', role overviews).",
    "hasCharacter": true,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/Topic1Subtopics6Character/preview.png"
  },
  {
    "key": "TreeDiagram4x2",
    "family": "diagram",
    "role": "body",
    "narrationShapes": [
      "hierarchy"
    ],
    "useWhen": "Breaking one root concept into exactly four branches that each have two supporting sub-points (a taxonomy or capability map).",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/TreeDiagram4x2/preview.png"
  },
  {
    "key": "WordDefinition",
    "family": "lesson-frame",
    "role": "body",
    "narrationShapes": [
      "definition",
      "single-concept"
    ],
    "useWhen": "Define a single term, jargon word, or concept with its plain-language meaning.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/WordDefinition/preview.png"
  },
  {
    "key": "YinYang2Points",
    "family": "comparison",
    "role": "body",
    "narrationShapes": [
      "contrast"
    ],
    "useWhen": "Frame a two-sided dichotomy or complementary pairing where both halves are essential and each is characterised by 1-2 attributes plus an icon.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/YinYang2Points/preview.png"
  },
  {
    "key": "NextLesson",
    "family": "lesson-frame",
    "role": "closer-preview",
    "narrationShapes": [
      "frame"
    ],
    "useWhen": "Preview the next lesson as its own standalone screen, placed before LessonSummary. One forward-looking line only.",
    "hasCharacter": false,
    "previewUrl": "https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts/NextLesson/preview.png"
  }
];
